module.exports = __webpack_public_path__ + "static/media/gameshow.4a1c75ac.png";